<template>
    <div class="about">
        <h1>Activate Account</h1>
        <div v-if="!success&&!failed">Activating...</div>
        <div v-if="failed">{{message}}</div>
        <div v-else>Thanks for join us, your account has been activated.</div>
    </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
    name: "Activate",
    props: {
        token: String
    },
    data() {
        return {
            processing: false,
            success: false,
            message: null
        };
    },
    computed: {
        failed() {
            return this.message && this.message.length > 0;
        }
    },
    mounted() {
        if(this.token) {
            this.loadData();
        }
        else{
            this.getError({
                title: "Activate Account Failed",
                message: "Invalid token"
            }).then(this.$notify);
        }
    },
    methods: {
        ...mapActions(["request", "getError"]),
        loadData() {
            let ctrl = this;
            ctrl.processing = true;
            ctrl.request({
                method: "GET",
                endpoint: `authenticate/activate`,
                params: {
                    token: this.token
                }
            })
                .then(() => {
                    this.success = true;
                })
                .catch(err => {
                    if(err && err.data && err.data.message){
                        this.message = err.data.message;
                    }
                    ctrl.getError({
                        err,
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
    }
};
</script>
<style scoped>
.about {
  padding: 16px 48px;
  color: #444;
  max-width: 800px;
  line-height: 24px;
}
p {
  margin: 24px 0px;
}
.faq {
    padding: 32px;
}
.title {
    font-size: 24px;
    padding: 16px 0;
}
.created {
    font-size: 12px;
    color: #333;
}
</style>